import React from 'react'
import classNames from 'classnames'

import { SliteLogo, SuperSourceIcon } from '@slite/components'
import { SuperSource } from '@slite/search-client'

export type SourceEntry = SuperSource | { iconUrl: string }

const CARD_SOURCES: SourceEntry[] = [
  SuperSource.SLACK_CHANNEL,
  SuperSource.HUBSPOT,
  SuperSource.LINEAR,
  SuperSource.JIRA,
  SuperSource.GOOGLE_DRIVE,
  SuperSource.GITHUB,
  SuperSource.ASANA,
  SuperSource.MICROSOFT_SHAREPOINT,
  SuperSource.ATTIO,
  SuperSource.INTERCOM,
  SuperSource.BIGQUERY,
  SuperSource.SALESFORCE,
]

export function SourceIconsRow({
  paddingLeft = 0,
  sources = CARD_SOURCES,
  showPlus = true,
  size = 14,
  gap = 6,
}: {
  paddingLeft?: number
  sources?: SourceEntry[]
  showPlus?: boolean
  size?: number
  gap?: number
}) {
  return (
    <div
      className="flexbox flexbox-align-center flexbox-wrap margin-top-4"
      style={{ gap, paddingLeft }}
    >
      {sources.map((s, i) =>
        typeof s === 'object' && 'iconUrl' in s ? (
          <span
            key={i}
            className="flexbox-inline flexbox-centered position-relative"
            style={{ width: size, height: size }}
          >
            <img src={s.iconUrl} style={{ width: size, height: size }} />
          </span>
        ) : s === SuperSource.SLITE ? (
          <SliteLogo
            key={i}
            variant="symbol"
            style={{ width: size, height: size }}
          />
        ) : (
          <SuperSourceIcon key={i} sourceType={s} size={size} />
        )
      )}
      {showPlus && (
        <span
          className={classNames(
            'font-weight-semibold flexbox-no-shrink',
            size === 14 && 'font-size-7'
          )}
          style={{
            marginLeft: 2,
            ...(size === 14 ? {} : { fontSize: Math.round(size * 0.6) }),
          }}
          // eslint-disable-next-line formatjs/no-literal-string-in-jsx
        >
          +
        </span>
      )}
    </div>
  )
}
